<template>
  <div v-if="levels.veryHigh != null" class="interpretation-bullet">
    <DxBullet
      :show-target="true"
      :show-zero-level="true"
      :color="colorOfBullet"
      :value="numericDisplayResult"
      :start-scale-value="0"
      :end-scale-value="levels.veryHigh"
    >
      <DxSize :width="150" :height="35" />
      <DxMargin :top="5" :bottom="0" :left="5" />
      <DxTooltip
        :enabled="true"
        :padding-top-bottom="2"
        :z-index="999999"
        :customize-tooltip="customizeTooltip"
      >
        <DxFont :size="18" />
      </DxTooltip>
    </DxBullet>
  </div>
</template>
<script>
import {
  DxBullet,
  DxFont,
  DxMargin,
  DxSize,
  DxTooltip,
} from 'devextreme-vue/bullet';

export default {
  components: {
    DxBullet,
    DxFont,
    DxMargin,
    DxSize,
    DxTooltip,
  },
  props: {
    cellData: {
      type: Object,
      default: () => {},
    },
    maxValue: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    levels() {
      const v =
        this.cellData?.data?.value ?? this.cellData?.value ?? {};
      return {
        veryLow: v?.very_low_level,
        low: v?.low_level,
        high: v?.high_level,
        veryHigh: v?.very_high_level,
      };
    },
    numericDisplayResult() {
      const v =
        this.cellData?.data?.value ?? this.cellData?.value ?? {};
      const s = v?.ResultadoPresentacion ?? v?.result_round ?? null;
      if (typeof s === 'string' && s.length > 0) {
        const n = Number(s.replace(/\./g, '').replace(',', '.'));
        if (!Number.isNaN(n)) return n;
      }
      return Number(v?.result);
    },
    colorOfBullet() {
      const v = this.numericDisplayResult;
      if (v < this.levels.veryLow) {
        return '#ff6384';
      }

      if (v < this.levels.low) {
        return '#ffce56';
      }

      if (v < this.levels.high) {
        return '#4bc0c0';
      }

      if (v < this.levels.veryHigh) {
        return '#ffce56';
      }

      return '#ff6384';
    },
    toolTipText() {
      const v = this.numericDisplayResult;
      if (v < this.levels.veryLow) {
        return this.$t('veryLowLevel');
      }

      if (v < this.levels.low) {
        return this.$t('lowLevel');
      }

      if (v < this.levels.high) {
        return this.$t('optimalLevel');
      }

      if (v < this.levels.veryHigh) {
        return this.$t('highLevel');
      }

      return this.$t('veryHighLevel');
    },
  },
  methods: {
    customizeTooltip() {
      return {
        text: this.toolTipText ?? '',
      };
    },
  },
};
</script>
<style>
.dx-datagrid .dx-data-row > td.bullet {
  padding-top: 0;
  padding-bottom: 0;
}

.interpretation-bullet {
  width: 100%;
  display: flex;
  /* El template de DevExtreme no centra el contenido por sí solo. */
  justify-content: center;
}
</style>
